/*
 * Google recaptcha V3
 */
const reCaptchaConfig = {
  "siteKey": "6LcIn6sZAAAAAFK2eoLMDyVIuwOzSIGrZTmq3S47",
};

export default reCaptchaConfig;
